import axios from 'axios'
import { CHALLENGE_TYPES } from '../../utils/constant'

/**
 * @param {string} attemptId
 * @returns
 */
export const getChallengesAIEvaluations = async (attemptId, challengeType) => {
  const response = await axios.get(
    challengeType === CHALLENGE_TYPES.VIDEO_RESPONSE
      ? 'video-stage-logs/ai-scores'
      : 'ai-evaluations',
    {
      params: { attemptId }
    }
  )
  return response
}

/**
 * @param {string} attemptId
 * @returns
 */
export const getChallengesOfLinearityScore = async (attemptId) => {
  const response = await axios.get(`attempt-results/linearity-score`, {
    params: { attemptId }
  })
  return response
}
